var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c(_vm.coinPage,{tag:"component",attrs:{"coin":_vm.coin}}):_c('div',{staticClass:"spinner"},[_c('spinner',{attrs:{"theme":"dark"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }